/**
 * React Query keys for the Home page (specs/home-page). Same shape as `challengesQueryKeys`.
 */
export const homeQueryKeys = {
  /** Today's prepared slate (global per UTC day). */
  slateToday: () => ['home', 'slate', 'today'] as const,
  /** The viewer's weekly quest progress. */
  quests: (userId: string | null) => ['home', 'quests', userId] as const,
} as const;
